<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="协议类型">
              <j-dict-select-tag
                v-model="queryParam.asoActivity"
                placeholder="请选择协议类型"
                dictCode="protocol_flag"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="协议名称">
              <a-input v-model="queryParam.name" placeholder="请输入协议名称" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="启用状态">
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="请选择启用状态"
                dictCode="obj_status"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="关联产品代码">
              <a-input v-model="queryParam.asoFundCode" placeholder="请输入关联产品代码"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col> -->
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="关联产品代码">
              <a-input
                v-model="queryParam.asoFundCode"
                placeholder="请输入关联产品代码"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button
        @click="back"
        type="primary"
        style="margin-right: 10px"
        icon="arrow-left"
        v-if="this.$route.params.fundCode"
        >返回</a-button
      >
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--      <a-button @click="showDialog = true"> <a-icon type="upload" /> 导入 </a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
          <a-menu-item key="2" @click="changeStatus('1')">批量启用</a-menu-item>
          <a-menu-item key="3" @click="changeStatus('0')">批量停用</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <a-modal
      title="上传文件"
      :visible="showDialog"
      @cancel="showDialog = false"
    >
      <a-upload-dragger
        name="file"
        :multiple="true"
        :file-list="fileList"
        accept=".zip"
        :before-upload="beforeUpload"
        :remove="handleRemove"
        :headers="tokenHeader"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或拖拽上传文件</p>
      </a-upload-dragger>
      <template slot="footer">
        <a-button key="back" @click="showDialog = false"> 取消 </a-button>
        <a-button
          :disabled="fileList.length === 0"
          :loading="uploading"
          key="submit"
          type="primary"
          icon="download"
          @click="upload"
        >
          导入
        </a-button>
      </template>
    </a-modal>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.status)"
            checked-children="启用"
            un-checked-children="未启用"
            @click="handleChange(record)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <protocol-modal ref="modalForm" @ok="modalFormOk"></protocol-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import ProtocolModal from './modules/ProtocolModal';
import JUpload from '../../../components/jeecg/JUpload';
import { getAction, postAction, uploadAction } from '../../../api/manage';

export default {
  name: 'Protocol',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JUpload,
    ProtocolModal,
  },
  data() {
    return {
      description: '协议管理页面',
      routerFundCode: '',
      showDialog: false,
      fileList: [],
      uploading: false,
      // 表头
      columns: [
        {
          title: '协议名称',
          align: 'center',
          dataIndex: 'name',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 12) + '...'
              : text;
          },
        },
        /*{
            title:'',
            align:"center",
            dataIndex: 'pdfSaveUrl',
            customRender:function (text) {
              return !text?"":(text.length>20?text.substr(0,20)+"...":text)
            }
          },*/
        {
          title: '类型',
          align: 'center',
          dataIndex: 'asoActivity_dictText',
          ellipsis: true,
        },
        {
          title: '协议文件',
          align: 'center',
          dataIndex: 'pdfSaveUrl',
          scopedSlots: { customRender: 'fileSlot' },
        },
        {
          title: '关联产品代码',
          align: 'center',
          dataIndex: 'asoFundCode',
          ellipsis: true,
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'status_dictText',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/protocol/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/protocol/delete',
        deleteBatch: process.env.VUE_APP_CMS_CONTENT + '/protocol/deleteBatch',
        updateStatus:
          process.env.VUE_APP_CMS_CONTENT + '/protocol/updateStatus',
        upload: process.env.VUE_APP_CMS_FILE_UPLOAD + '/upload',
        batchUpload: process.env.VUE_APP_CMS_CONTENT + '/protocol/batchUpload',
      },
      dictOptions: {},
    };
  },
  computed: {},
  created() {
    if (!this.disableMixinCreated) {
      console.log(' -- mixin created -- ');
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
    }
  },
  methods: {
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.upload, formData)
        .then((res) => {
          if (res.success) {
            postAction(this.url.batchUpload, {
              fileUrls: res.result.files.join(','),
            }).then((resp) => {
              if (resp.success) {
                this.$message.success(res.message);
                this.loadData();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
        });
    },
    initDictConfig() {},
    back() {
      this.$router.push({ name: 'product-ProductsFundInfo-FundInfoList' });
    },
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      this.routerFundCode = this.$route.params.fundCode;
      console.log('fundCode', this.routerFundCode);
      var params = this.getQueryParams(); //查询条件
      if (this.routerFundCode) {
        params.asoFundCode = this.routerFundCode;
      }
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    //批量启用、停用
    changeStatus(num) {
      var title_tmp = '';
      var content_tmp = '';
      if (num === '1') {
        title_tmp = '确认启用';
        content_tmp = '是否启用选中数据';
      } else {
        title_tmp = '确认停用';
        content_tmp = '是否停用选中数据';
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
          ids += this.selectedRowKeys[i] + ',';
        }
        var that = this;
        this.$confirm({
          title: title_tmp,
          content: content_tmp,
          onOk: function () {
            that.loading = true;
            postAction(that.url.updateStatus, { ids: ids, type: num })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  //刷新页面
                  that.loadDataTmp();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },

    //启用、停用
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要停用所选数据?';
      var that = this;
      var type = record.status === '1' ? '0' : '1';
      this.$confirm({
        title: record.status === '1' ? '停用' : '启用',
        content: record.status === '1' ? strClose : strOpen,
        onOk() {
          postAction(that.url.updateStatus, {
            ids: record.id,
            type: type,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadDataTmp();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },

    isChecked(statusTemp) {
      if (statusTemp === '1') {
        return true;
      } else return false;
    },

    loadDataTmp() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      this.loading = true;
      getAction(this.url.list).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
